const CANONICAL_HOST = "www.easyareacodes.com";

export function getSiteOrigin(): string {
  const fromEnv = process.env.NEXT_PUBLIC_SITE_URL;

  if (fromEnv) {
    const url = new URL(fromEnv);
    url.protocol = "https:";
    url.hostname = CANONICAL_HOST;
    url.pathname = "";
    url.search = "";
    url.hash = "";
    return url.origin;
  }

  return `https://${CANONICAL_HOST}`;
}

function hasFileExtension(path: string): boolean {
  const segment = path.split("/").pop() ?? "";
  return segment.includes(".") && !segment.endsWith(".");
}

export function toCanonicalPath(path: string): string {
  if (path === "" || path === "/") {
    return "/";
  }

  const normalized = path.startsWith("/") ? path : `/${path}`;

  if (hasFileExtension(normalized)) {
    return normalized;
  }

  return normalized.endsWith("/") ? normalized : `${normalized}/`;
}

export function toCanonicalUrl(path: string = "/"): string {
  const origin = getSiteOrigin();

  if (path === "" || path === "/") {
    return `${origin}/`;
  }

  return `${origin}${toCanonicalPath(path)}`;
}

export function isBareProductionHost(host: string): boolean {
  const hostname = host.split(":")[0].toLowerCase();
  return hostname === "easyareacodes.com";
}
